<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<input-form-text textInput="Título" :required="true" v-model="form.titulo"
						:value="form.titulo"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Imagem</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages.length" ref="fupload" :url="'/v1/destaques/upload'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false"></file-upload>
							<items-edit v-else :files="allImages"
								url="/v1/destaques/upload" id="id"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Imagem Mobile</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImagesMobile.length" ref="fuploadMobile" :url="'/v1/destaques/upload/mobile'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false"></file-upload>
							<items-edit v-else :files="allImagesMobile"
								url="/v1/destaques/upload/mobile" id="id"></items-edit>
						</div>
					</div>
					<input-form-text textInput="Link" v-model="form.link" :value="form.link"></input-form-text>
					<div class="form-group">
						<select-form v-model="form.link_janela" :value="form.link_janela" name="Abrir numa nova Janela" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione"></select-form>
					</div>
					<div class="form-group">
						<select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit,
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Destaques',
			form: {
				titulo: '',
				link: '',
				link_janela: '',
				ativo: '1',
			},
			allImages: [],
			allImagesMobile: [],
			isActiveBtn: false,
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				let resp = await req(`/v1/destaques/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				if (!this.allImages.length) {
					this.isActive = false
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				if (!this.allImagesMobile.length) {
					this.isActive = false
					const tbm = this.$refs.fuploadMobile.$children.filter(i => i.$refs.tb)
					const mm = tbm[0]
					await mm.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/destaques')
			} else {
				let resp = await req('/v1/destaques', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				const tbm = this.$refs.fuploadMobile.$children.filter(i => i.$refs.tb)
				const mm = tbm[0]
				await mm.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/destaques')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		getDados() {
			req(`/v1/destaques/${this.$route.params.id}`).then(resp => {
				this.form.ativo = resp.ativo
				this.form.titulo = resp.titulo
				this.form.link = resp.link
				this.form.link_janela = resp.link_janela
				this.allImages = resp.imagem ? [{ id: this.$route.params.id, images: resp.imagem }] : ''
				this.allImagesMobile = resp.imagem_mobile ? [{ id: this.$route.params.id, images: resp.imagem_mobile }] : ''
				this.isActive = false
			}).catch(response => {
				'error: ' + response
				erro()
			})
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
